import { useMemo } from "react";
import { RangeContext } from ".";
import { useVideoSource } from "../VideoSource";
import { PartialRange } from "../../types/partialRange";

export interface RangeProps {
  range?: PartialRange;
  children?: React.ReactNode;
}

export const RangeProvider = ({ range, children }: RangeProps) => {
  const { duration } = useVideoSource();
  const rangeExists = range !== undefined;

  const start = range?.start ?? 0;
  const end = range?.end ?? duration;

  const value = useMemo(
    () => ({
      range: rangeExists ? { start, end } : undefined,
      adjustedDuration: end - start,
      currentTimeOffset: start,
    }),
    [end, rangeExists, start]
  );

  return (
    <RangeContext.Provider value={value}>{children}</RangeContext.Provider>
  );
};
